<div class="exercise-finish-wrap">
  <div class="finish-icon">
    <img src="{{assetsRoute}}/picture/camp/right.png" alt="" />
  </div>
  <p class="color333 fontSize20 fontBold">作答提交成功</p>
  <p class="color666 fontSize14" *ngIf="!isNeedCorrect">谢谢回答</p>
  <p class="color666 fontSize14" *ngIf="isNeedCorrect">谢谢回答 <br />我们会在第一时间点评批复 <br />请留意公众号的推送消息</p>

  <div class="finish-btn" (click)="goAnswer(1)">看看其他学员的作答</div>
  <div class="fontSize14 color333" (click)="goAnswer(0)">查看我的作答 ></div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-exercise-work/exercise-work-finish/finish.component.html